import { i18n } from "./utils";

export const enum dataModeEnum {new , edit, detail};

export const healthDataProps: any = {
  observations: 'observations',
  pathologies: 'pathologies',
  medicine: 'medicines',
  intervention: 'interventions',
  allergy: 'allergies',
  fcs: 'fcs',
};

export const healthDataList: any = [
  { type: 'pathologies', path: 'pathologies' },
  { type: 'medicines', path: 'medicine' },
  { type: 'interventions', path: 'intervention' },
  { type: 'allergies', path: 'allergy' },
  { type: 'diagnosis', path: 'diagnosis' },
];

export const personalDataTextFieldList = [
  {
    column: 'left', row: [
      { name: 'serviceNumber', type: 'phone' },
      { name: 'height', type: 'text' },
      { name: 'birthdate', type: 'date' },
      { name: 'race', type: 'select' },
      { name: 'sex', type: 'select' },
      { name: 'access', type: 'select' },
      { name: 'username', type: 'text' },
      { name: 'group', type: 'select' },
    ],
  },
  {
    column: 'right', row: [
      { name: 'maritalStatus', type: 'select' },
      { name: 'education', type: 'select' },
      { name: 'ethnicity', type: 'select' },
      { name: 'language', type: 'select' },
      { name: 'weightBaseline', type: 'text' },
    ],
  },
];

export const HealthInsuranceTextFieldList = [
  { name: 'accountId', type: 'text' },
  { name: 'healthCenter', type: 'select' },
  { name: 'professional', type: 'text' },
];

export const newProfessionalTextFieldList = [
  { name: 'firstName', type: 'text', required: true },
  { name: 'middleName', type: 'text' },
  { name: 'lastName', type: 'text' },
  // `sorted: false` → el desplegable conserva su orden propio (jerarquía de roles, Sí/No)
  // en vez de alfabetizarse.
  { name: 'access', type: 'select', required: true, sorted: false },
  { name: 'installerPermissions', type: 'select', sorted: false },
  { name: 'username', type: 'text', required: true },
  { name: 'email', type: 'text', required: true },
  { name: 'group', type: 'select', required: true },
];

export const newDeviceTextFieldList = [
  { name: 'hwSerialNo', type: 'text' },
  { name: 'deviceType', type: 'select' },
  { name: 'group', type: 'select' },
];

export const newWarehouseTextFieldList = [
  { name: 'firstName', type: 'text', required: true },
  { name: 'username', type: 'text' },
  { name: 'email', type: 'text' },
  { name: 'group', type: 'select', required: true },
];

export const deviceStatusFieldList = [
  {
    column: 'generalLeft', row: [
      { name: 'deviceTypeCode', type: 'text' },
      { name: 'deviceManufacturer', type: 'text' },
      { name: 'deviceModel', type: 'text' },
      { name: 'deviceStartupTimestamp', type: 'text' },
    ],
  },
  {
    column: 'generalRight', row: [
      { name: 'deviceSoVersion', type: 'text' },
      { name: 'deviceClientVersion', type: 'text' },
      { name: 'deviceLastSeen', type: 'text' },
    ],
  },
  {
    column: 'mobile', row: [
      { name: 'mobile.networkType', type: 'text' },
      { name: 'mobile.signalLevel', type: 'text' },
    ],
  },
  {
    column: 'gps', row: [
      { name: 'gps.position', type: 'link' },
    ],
  },
  {
    column: 'wireless', row: [
      { name: 'wireless.ssid', type: 'text' },
      { name: 'wireless.signalLevel', type: 'text' },
    ],
  },
];

export const newGroupTextFieldList = [
  { name: 'code', type: 'text' },
  { name: 'subgroup', type: 'select' },
  { name: 'maxDeviceTypePerUser', type: 'text' },
];

export const optionsAccessUser = [
  {
    value: 'NONE',
    label: i18n("NONE"),
  },
/*  {
    value: 'PATIENT',
    label: i18n("USER"),
  },*/
  {
    value: 'BENEFICIARY',
    label: i18n("BENEFICIARY"),
  }
];

export const optionsAccessUserRp = [
  {
    value: 'NONE',
    label: i18n("NONE"),
  },
  /*  {
      value: 'PATIENT',
      label: i18n("USER"),
    },*/
  {
    value: 'BENEFICIARY',
    label: i18n("BENEFICIARY"),
  },
  {
    value: 'WAREHOUSE',
    label: i18n("WAREHOUSE"),
  },
];


export const optionsAccessProfessional = [
  { label: i18n('STANDARD'), value: 'STANDARD' },
  { label: i18n('ADMINISTRATOR'), value: 'ADMINISTRATOR' },
  { label: i18n('NURSE'), value: 'NURSE' },
  { label: i18n('INSTALLER'), value: 'INSTALLER' },
];

/**
 * Rol SUPERADMINISTRATOR: solo personal de TMC. Solo lo ofrece un superadmin, y gdp-api solo acepta que un superadmin
 * lo asigne o edite a quien lo tiene (SuperadminRoleRule).
 */
export const optionAccessSuperadmin = { label: i18n('SUPERADMINISTRATOR'), value: 'SUPERADMINISTRATOR' };

/**
 * Rol BILLING (solo facturación). Solo lo ofrece un superadmin: gdp-api exige además superadmin y que el usuario
 * esté en el grupo raíz, porque la facturación cruza clientes.
 */
export const optionAccessBilling = { label: i18n('BILLING'), value: 'BILLING' };

export const accessOptionsProfessionalFor = (applicantAccess: string | undefined) =>
  applicantAccess === 'SUPERADMINISTRATOR'
    ? [...optionsAccessProfessional, optionAccessSuperadmin, optionAccessBilling]
    : optionsAccessProfessional;

export const optionsYesNo = [
  { label: i18n('Yes'), value: true },
  { label: i18n('No'), value: false },
];

// De qué objeto del formulario de alta se lee cada campo del catálogo. Qué campos
// son obligatorios ya NO se decide aquí: viene resuelto por grupo desde el backend
// (GET /groups/{id}/required-fields/resolved). Este mapa solo sirve para saber si
// un campo requerido está relleno en el alta.
//
// Los campos que se configuran tras el alta (clasificadores, profesional de
// referencia, tipo de servicio) no están en este formulario, por eso no aparecen
// aquí y se omiten del aviso.
export const ALTA_FIELD_SOURCE: Record<string, 'data' | 'personalData'> = {
  firstName: 'data',
  middleName: 'data',
  lastName: 'data',
  birthdate: 'data',
  height: 'data',
  sex: 'data',
  race: 'data',
  serviceNumber: 'data',
  principalAuxId: 'data',
  secondaryAuxId: 'data',
  observations: 'data',
  idCard: 'personalData',
  weightBaseline: 'personalData',
  address1: 'personalData',
  address2: 'personalData',
  city: 'personalData',
  state: 'personalData',
  postalCode: 'personalData',
  county: 'personalData',
  country: 'personalData',
  region: 'personalData',
  commune: 'personalData',
  phone1: 'personalData',
  phone2: 'personalData',
  email: 'personalData',
  maritalStatus: 'personalData',
  language: 'personalData',
  education: 'personalData',
  ethnicity: 'personalData',
};

// De los códigos requeridos (resueltos por grupo), devuelve los que están sin
// rellenar en el alta. Los que no son comprobables en este formulario se omiten.
export const getMissingServiceMinFields = (data: any, personalData: any, requiredCodes: string[]): string[] =>
  (requiredCodes || []).filter((code) => {
    const source = ALTA_FIELD_SOURCE[code];
    if (!source) {
      return false; // no comprobable en el alta (p.ej. campos relacionales)
    }
    const obj = source === 'data' ? data : personalData;
    if (code === 'sex' || code === 'race') {
      return !obj?.[code]?.id && !obj?.[code]?.code;
    }
    if (code === 'height' || code === 'weightBaseline' || code === 'serviceNumber') {
      return !obj?.[code] || Number(obj[code]) === 0;
    }
    const value = obj?.[code];
    return value === null || value === undefined || String(value).trim() === '';
  });

// Campos del catálogo que SIEMPRE son obligatorios porque el alta ya los exige al
// crear el usuario (igual que Acceso y Grupo, que ni siquiera están en el catálogo).
// En el selector aparecen marcados y bloqueados, y se fuerzan al guardar.
export const ALWAYS_REQUIRED_FIELDS: string[] = ['firstName'];

// Orden de presentación de los campos, siguiendo la lectura de la ficha del usuario
// (bloque identidad → datos de servicio → dirección/contacto → observaciones →
// clasificadores). En una rejilla de 3 columnas (fila a fila) reproduce el orden de
// la ficha. Se usa en el selector de campos del grupo y en el aviso del alta. Los
// códigos no listados quedan al final.
export const REQUIRED_FIELDS_DISPLAY_ORDER: string[] = [
  'firstName', 'idCard', 'language',
  'middleName', 'maritalStatus', 'education',
  'lastName', 'race', 'height',
  'birthdate', 'ethnicity', 'weightBaseline',
  'sex', 'serviceNumber', 'serviceType',
  'principalAuxId', 'secondaryAuxId',
  'address1', 'address2', 'city', 'state', 'postalCode', 'county', 'country', 'region', 'commune',
  'phone1', 'phone2', 'email',
  'observations',
  'program', 'admissionCondition', 'referenceProfessional',
];

// Ordena una lista de códigos de campo según REQUIRED_FIELDS_DISPLAY_ORDER.
export const sortByFieldDisplayOrder = (codes: string[]): string[] => {
  const indexOf = (code: string) => {
    const i = REQUIRED_FIELDS_DISPLAY_ORDER.indexOf(code);
    return i === -1 ? Number.MAX_SAFE_INTEGER : i;
  };
  return [...(codes || [])].sort((a, b) => indexOf(a) - indexOf(b));
};

// Códigos de campo mínimo que sabemos reconocer (catálogo del grupo + campos del alta).
const SERVICE_MIN_FIELD_CODES = new Set<string>([
  ...REQUIRED_FIELDS_DISPLAY_ORDER,
  ...Object.keys(ALTA_FIELD_SOURCE),
]);

// Un campo que falta puede ser estático ("race") o un clasificador ("classifier:Programas",
// o el fallback "classifierType:<id>" si el backend no resolvió el nombre).
export const isServiceMinFieldCode = (code: string): boolean =>
  SERVICE_MIN_FIELD_CODES.has(code) || code.startsWith('classifier:') || code.startsWith('classifierType:');

// Etiqueta traducida de un código de campo mínimo.
export const serviceMinFieldLabel = (code: string): string => {
  if (code?.startsWith('classifier:')) {
    return i18n('text.field.classifier') + ': ' + code.slice('classifier:'.length);
  }
  if (code?.startsWith('classifierType:')) {
    return i18n('text.field.classifier') + ': ' + code.slice('classifierType:'.length);
  }
  return i18n('text.field.' + code);
};

// El backend deja los campos que faltan como texto: en el mensaje del error 2015
// ("The following fields are missing: a, b") y en la nota del histórico ("a, b").
// Sólo se acepta el texto si TODOS los tokens son códigos conocidos, para no
// confundir una nota escrita a mano con la lista automática.
export const parseServiceMinFieldsText = (text?: string | null): string[] => {
  if (!text) return [];
  const tokens = String(text)
    .replace(/^.*fields are missing:\s*/i, '')
    .split(',')
    .map((token) => token.trim())
    .filter(Boolean);
  if (tokens.length === 0 || !tokens.every(isServiceMinFieldCode)) return [];
  return tokens;
};

// Recorre las notas de una entrada del histórico y devuelve la primera lista
// de campos que falten reconocible.
export const parseServiceMinFieldsFromNotes = (noteList: any[]): string[] => {
  for (const item of noteList ?? []) {
    const codes = parseServiceMinFieldsText(item?.note);
    if (codes.length > 0) return codes;
  }
  return [];
};

// --- Soporte remoto de dispositivos (AnyDesk hoy; agnóstico de proveedor) ---
// Plantilla de deep-link por proveedor. {address} se sustituye por el código/ID.
// Cambiar de proveedor el día de mañana = añadir/editar una entrada aquí (y el back
// guarda el `provider` por dispositivo). Opcionalmente overridable desde runtimeConfig.
export const REMOTE_SUPPORT_URI_TEMPLATES: Record<string, string> = {
  ANYDESK: 'anydesk:{address}',
  TEAMVIEWER: 'teamviewer8://control?device={address}',
  RUSTDESK: 'rustdesk://connect/{address}',
};

// Proveedores ofrecidos en el desplegable de edición.
export const REMOTE_SUPPORT_PROVIDERS: string[] = Object.keys(REMOTE_SUPPORT_URI_TEMPLATES);

// Construye el enlace lanzable a partir de { provider, address }. null si falta dato o plantilla.
export const buildRemoteSupportUri = (
  remoteSupport?: { provider?: string | null; address?: string | null } | null,
): string | null => {
  const provider = remoteSupport?.provider;
  const address = remoteSupport?.address;
  if (!provider || !address) return null;
  const template = REMOTE_SUPPORT_URI_TEMPLATES[provider];
  if (!template) return null;
  // El valor se guarda formateado ("520 799 200"); el deep-link necesita el código sin espacios.
  return template.replace('{address}', encodeURIComponent(address.replace(/\s+/g, '')));
};
